import React, { Component } from 'react'
import { connect } from 'react-redux'

import Setting from '../components/setting/setting'
import { selectTab, changeToken, saveToken, cancelToken, changeIntegration, toggleExpansionPanel, showPopup, changeInputUrl, cancelUrl, saveUrl } from '../store/action/setting.action'

//делаем враппер для компонента с прокидыванием необходимых пропсов
class SettingContainer extends Component {
    render(){
        return(
            this.props.isAuth ? <Setting {...this.props}/>: null
        )
    }
}

// //прокидываем данные из стор в пропс
const mapStateToProps = store => {
    return {
        store: store.setting,
        isAuth: store.authUIS.user_is_auth
    }
}

//прокидываем диспатч из стор в пропс
const mapDispatchToProps = dispatch => {
    return {
        action: {
            setSelTab: val => dispatch(selectTab(val)),
            changeToken: text => dispatch(changeToken(text)),
            saveToken: (token, appId, customerId) => dispatch(saveToken(token, appId, customerId)),
            cancelToken: ()=>dispatch(cancelToken()),
            changeIntegration: (status, appId) => dispatch(changeIntegration(status, appId)),
            toggleExpansionPanel: ()=>dispatch(toggleExpansionPanel()),
            showPopup: anchor => dispatch(showPopup(anchor)),
            changeInputUrl: text => dispatch(changeInputUrl(text)),
            saveUrl: (url, appId) => dispatch(saveUrl(url, appId)),
            cancelUrl: ()=>dispatch(cancelUrl()),
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingContainer)